import { Grid, Theme } from "@mui/material";
import { EnsolversOpsUser, WelcomeFormInfo } from "../../models/EnsolversOpsUser";
import { AppListItem } from "../AppListItem";
import PortraitOutlinedIcon from "@mui/icons-material/PortraitOutlined";
import BadgeOutlinedIcon from "@mui/icons-material/BadgeOutlined";
import CakeOutlinedIcon from "@mui/icons-material/CakeOutlined";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import ManageAccountsOutlinedIcon from "@mui/icons-material/ManageAccountsOutlined";
import GroupOutlinedIcon from "@mui/icons-material/GroupOutlined";
import AssistantPhotoOutlinedIcon from "@mui/icons-material/AssistantPhotoOutlined";
import LocalPhoneOutlinedIcon from "@mui/icons-material/LocalPhoneOutlined";
import BeachAccessIcon from "@mui/icons-material/BeachAccess";
import GitHubIcon from "@mui/icons-material/GitHub";
import BeachAccessOutlinedIcon from "@mui/icons-material/BeachAccessOutlined";
import OpsDateUtils from "../../utils/OpsDateUtils";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import SchoolIcon from "@mui/icons-material/School";
import PetsIcon from "@mui/icons-material/Pets";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import VideogameAssetIcon from "@mui/icons-material/VideogameAsset";
import ExtensionIcon from "@mui/icons-material/Extension";
import QueueMusicIcon from "@mui/icons-material/QueueMusic";
import GenericForm from "../../external/ensolvers-core-frontend-mui/components/Common/GenericForm";
import { SpinnerWrapper } from "../SpinnerWrapper";
import { UserUpdateModal } from "../UserProfile/UserUpdateModal";
import { useContext } from "react";
import { PersonalInformationContext } from "../../routes/PersonalInfo";
import featureToggleList from "../../utils/toggleConfig.json";
import { Features } from "../../utils/Features";
import { useFeatureToggle } from "../../external/ensolvers-core-frontend-mui/hooks/useFeatureToggle";
import OpsAvatarComponent from "../OpsAvatarComponent";
import { ButtonComponent } from "../ButtonComponent";
import { UserAvatar } from "../UserProfile/UserAvatar";
import OpsPanel from "../OpsPanel";
import userIcon from "../../img/icons/user_icon.svg"
import factCheck from "../../img/icons/fact_check.svg"
import { ColorUtils } from "../../utils/ColorUtils";
import { useStyles } from "../Main/formStyles";

export const PersonalData = () => {
  const {
    user,
    isLoading,
    isRequestPending,
    isProfileOwner,
    canEdit,
    userUpdate,
    setUserUpdate,
    userAvatarUpdate,
    onSave,
    clearUserUpdate,
    showAdditionalVacationAmount,
    setIsLoading,
    setUser,
    setUserAvatarUpdate,
  } = useContext(PersonalInformationContext);
  const welcomeFormInfo: WelcomeFormInfo = user.welcomeFormInfo ?? {};
  const [isVacationReportEnabled] = useFeatureToggle(featureToggleList, Features.VACATION_REPORT);

  const customStyles = useStyles();

  return (
    <>
      <Grid container direction="column" gap={2}>
        <OpsPanel
        title="Personal data"
        svg={userIcon}
        panelMenu={
            <ButtonComponent
              startIcon={<EditOutlinedIcon htmlColor={"#918D8D"} />}
              style={{ display: "flex", color: "#918D8D", fontSize: "0.7rem",height:"auto", margin:"-1em -1em 1em 1em", padding:"0em 1.5em"}}
              onClick={() => setUserUpdate(user)}
              text={"Edit"}
            />
          }
        >
          <Grid container alignItems={"center"} justifyContent={"center"} spacing={2}>
            <Grid container item justifyContent={"center"} alignItems={"center"} xs={12} md={3}>
              <OpsAvatarComponent
                avatarUrl={user?.avatarUrl}
                forceGenericAvatar={true}
                sx={{ width: { xs: 200, md: 150}, height: { xs: 200, md: 150}, cursor: "pointer" }}
                onClick={() => setUserAvatarUpdate(user)}
              />
            </Grid>
            <Grid item xs={12} md={3} sx={{ paddingTop: "2em" }}>
              <AppListItem icon={<BadgeOutlinedIcon />} primaryText={`First Name`} secondaryText={`${user?.firstName}`} />
              <AppListItem icon={<BadgeOutlinedIcon />} primaryText={`Last Name`} secondaryText={`${user?.lastName}`} />
              <AppListItem
                icon={<CalendarTodayOutlinedIcon />}
                primaryText={`Joined`}
                secondaryText={`${OpsDateUtils.ensureFormatDateUTC(user?.shortStart)}`}
              />
              <AppListItem icon={<EmailOutlinedIcon />} primaryText={`Email`} secondaryText={`${user?.email}`} />
            </Grid>
            <Grid item xs={12} md={3}>
              <AppListItem
                icon={<CakeOutlinedIcon />}
                primaryText={`Birthday`}
                secondaryText={user?.shortBirthday ? `${OpsDateUtils.formatUTCAsDDMMM(user?.shortBirthday)}` : "-"}
              />
              <AppListItem icon={<LocalPhoneOutlinedIcon />} primaryText={`Phone`} secondaryText={`${user?.phone || "-"}`} />
              <AppListItem
                icon={<AssistantPhotoOutlinedIcon />}
                primaryText={`Country, Region`}
                secondaryText={(user?.country ? `${user.country}` : "-") + (user?.region ? `, ${user.region}` : "")}
              />
              <AppListItem icon={<PortraitOutlinedIcon />} primaryText={`Slack User Id`} secondaryText={`${user?.slackUserId || "-"}`} />
            </Grid>

            <Grid item xs={12} md={3}>
              <AppListItem icon={<GitHubIcon />} primaryText={`Github Username`} secondaryText={`${user?.githubUsername || "-"}`} />
              <AppListItem
                icon={<ManageAccountsOutlinedIcon />}
                primaryText={`Primary Role`}
                secondaryText={`${user?.primaryRole?.replace(/_/g, " ") || "-"}`}
              />
              <AppListItem
                icon={<GroupOutlinedIcon />}
                primaryText={`Secondary Role`}
                secondaryText={`${user?.secondaryRole?.replace(/_/g, " ") || "-"}`}
              />
              {showAdditionalVacationAmount() && (
                <AppListItem
                  icon={<BeachAccessIcon />}
                  primaryText={`Vacations Computed Since`}
                  secondaryText={`${OpsDateUtils.ensureFormatDateUTC(user?.vacationsComputedSince)}`}
                />
              )}
              {isVacationReportEnabled && user?.vacationAccumulation !== 10 && (
                <AppListItem
                  icon={<BeachAccessOutlinedIcon />}
                  primaryText={`Vacation Accumulation per year (days)`}
                  secondaryText={`${user?.vacationAccumulation || "-"}`}
                />
              )}
            </Grid>
          </Grid>
        </OpsPanel>      

        <OpsPanel
          title="Welcome Form Info"
          svg={factCheck}
        >
          <Grid container alignItems={"center"} justifyContent={"space-evenly"} spacing={2}>
            <Grid item xs={12} md={3} sx={{ paddingTop: "2em" }}>
              <AppListItem icon={<SchoolIcon />} primaryText={`Student`} secondaryText={`${welcomeFormInfo?.student ? "Yes" : "No"}`} />
              <AppListItem icon={<PetsIcon />} primaryText={`Pets`} secondaryText={`${welcomeFormInfo?.pets || "-"}`} />
            </Grid>
            <Grid item xs={12} md={3} sx={{ paddingTop: "2em" }}>
              <AppListItem
                icon={<AutoAwesomeIcon />}
                primaryText={`Personal Description`}
                secondaryText={`${welcomeFormInfo?.wordDescription || "-"}`}
              />
              <AppListItem
                icon={<VideogameAssetIcon />}
                primaryText={`Favourite Game`}
                secondaryText={`${welcomeFormInfo?.favouriteGame || "-"}`}
              />
            </Grid>
            <Grid item xs={12} md={3} sx={{ paddingTop: "2em" }}>
              <AppListItem icon={<ExtensionIcon />} primaryText={`Hobbies`} secondaryText={`${welcomeFormInfo?.hobbies || "-"}`} />
              <AppListItem
                icon={<QueueMusicIcon />}
                primaryText={`Favourite Genre/Band`}
                secondaryText={`${welcomeFormInfo?.musicPreferences || "-"}`}
              />
            </Grid>
          </Grid>
        </OpsPanel>
      </Grid>

      <UserAvatar
        userAvatarUpdate={userAvatarUpdate}
        isLoading={isLoading}
        setIsLoading={setIsLoading}
        setUserAvatarUpdate={setUserAvatarUpdate}
        setUser={setUser}
      />

      {userUpdate && (
        <GenericForm<EnsolversOpsUser>
          dialog={true}
          open={true}
          disableMultipleSubmit
          instance={user}
          title={isLoading ? "" : "Edit"}
          onSave={onSave}
          onCancel={clearUserUpdate}
          renderContent={(register, errors, control) => (
            <SpinnerWrapper isLoading={isRequestPending}>
              <UserUpdateModal
                isVacationReportEnabled={isVacationReportEnabled}
                control={control}
                register={register}
                errors={errors}
                canEdit={canEdit}
              />
            </SpinnerWrapper>
          )}
          validateBeforeClosing
          headerStyles={{ color: ColorUtils.ENSOLVERS_ORANGE_REBRANDING, marginBottom:-10, marginTop:10 }}
          buttonStyles={{ marginRight: 20, color: 'white', backgroundColor: ColorUtils.ENSOLVERS_ORANGE_REBRANDING, marginBottom: 10 }}
          cancelButtonStyles={{ color: ColorUtils.ENSOLVERS_ORANGE_REBRANDING, border: `1px solid ${ColorUtils.ENSOLVERS_ORANGE_REBRANDING}`, marginBottom: 10 }}
          dialogStyles={customStyles.root}
          forceFormOrientationCol={true}
        />
      )}
    </>
  );
};
